module.exports = __webpack_public_path__ + "static/scale-model-mode-8e41527ebae0965eb82d13d7c7a50e23.gif";